export default "__VITE_PUBLIC_ASSET__a80594e0__"